import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/app/store/auth.store";
import { canAny } from "@/lib/utils/permissions";

// Keeps someone from deep-linking into a screen their role has no business
// on. The API refuses the same request independently -- this only spares them
// a page of 403s.
export function RoleRoute({ require }) {
  const permissions = useAuthStore((s) => s.permissions);
  const required = Array.isArray(require) ? require : [require];

  if (!canAny(permissions, ...required)) return <Navigate to="/" replace />;
  return <Outlet />;
}
